import { useState } from "react";

const useValidateCpf = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const validateCpf = async (cpf) => {
    setLoading(true);
    setError("");

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_ENDPOINT}/webapp/validate/company-customer-cpf`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ cpf }),
        }
      );

      const data = await response.json();

      if (data.success && data.authorized) {
        if (data.token) {
          localStorage.setItem("authToken", data.token);
        }
        return {
          success: true,
          customerName: data.customerName,
          token: data.token,
        };
      } else {
        setError(data.message || "Usuário não autorizado");
        return {
          success: false,
          error: data.message || "Usuário não autorizado",
        };
      }
    } catch (err) {
      const errorMessage = "Erro ao validar CPF. Tente novamente.";
      setError(errorMessage);
      return {
        success: false,
        error: errorMessage,
      };
    } finally {
      setLoading(false);
    }
  };

  const clearError = () => {
    setError("");
  };

  return {
    validateCpf,
    loading,
    error,
    clearError,
  };
};

export default useValidateCpf;
